export enum FeatureLevel {
  AtccFull = "atcc-full",
  AtccTrial = "atcc-trial",
  MtccFull = "mtcc-full",
  MtccLite = "mtcc-lite",
}
